<template>
    <section id="mainContainer">
        <userHeader ref="userHeader"></userHeader>
        <section class="mid-container">
            <section class="page-banner-section"
                :style="{ 'background-image': `url(${require('@/assets/images/clients-banner.jpg')})` }">
                <div class="container">
                    <h1>{{ constants['MEET_OUR_CUSTOMERS_TEXT'] }}</h1>
                </div>
            </section>

            <section class="customers-section">
                <div class="container">
                    <h2>{{ constants['OUR_CLIENTS_TEXT'] }}</h2>
                    <div class="customers-inner">
                        <div class="custom-row">
                            <!-- <div class="customers-box">
                                <div class="flip-card">
                                   <button class="become_custome__btn" data-toggle="modal" data-target="#becomeCustomeModal">
                                    <img src="@/assets/images/client.jpg" alt="Avatar" />
                                   </button>
                                  </div>
                              </div> -->

                            <div class="customers-box" v-for="(item, index) in clientsData" :key="index">
                                <div class="flip-card">
                                    <div class="flip-card-inner">
                                        <div class="flip-card-front">
                                            <img :src="getCdnImageAddress(item.companyLogo, `w_350,h_285/`)" alt="Avatar" />
                                        </div>
                                        <div class="flip-card-back">
                                            <div class="flip-card-back-inner">
                                                <h3>{{ item.title }}</h3>
                                                <div class="flip_txt">
                                                    {{ useStripHtml(getTruncatedText(getClientDescription(item), 130)) }}
                                                  
                                                    <!-- <p v-html="item.description"></p> -->
                                                </div>
                                                <div class="url_btn" v-if="shouldShowClientReadMore(item)">
                            <!-- <a href="javascript:void(0);" id="readMoewa" @click="toggleClientDescription(item.id)">
                                {{ isExpandedClient(item.id) ? '<< Read Less' : 'Read More >>' }}</a> -->
                                <router-link :to="`/client/${item.slug}`" id="readMoewa" @click="closeMenu()">Read More >></router-link>
                         </div>
                                                <!-- <div class="url_btn"><a href="case-study.html">Read More ></a></div> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


        </section>
        <userFooter></userFooter>
    </section>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import userHeader from "@/components/userHeader.vue";
import axios from 'axios';
import { useRoute } from 'vue-router';
import userFooter from "@/components/userFooter.vue";
import constants from '@/utils/en-US-User.json';
import { environment } from '@/config/environment';
import { API_BASE_URL } from '@/config/api.config';

interface Clients {
    id: number;
    title: string;
    description: string;
    companyImage: string;
    companyLogo: string;
    challenge: string;
    solution: string;
    result: string;
    status: string;
    slug: string;
}

export default defineComponent({
    name: "our-clients",
    components: {
        userHeader,
        userFooter
    },
    data() {
        return {
            constants,
            clientsId: '',
            clientsData: [] as Clients[],
            expandedClientIds: new Set<number>()

        };
    },
    created() {
        this.fetchClientsData();
    },
    methods: {
        async fetchClientsData() {
            try {
                const response = await axios.get(`${API_BASE_URL}/client/?status=1`);
                this.clientsData = response.data;
            } catch (err) {
                console.error(err);
            }
        },
        getClientDescription(client: Clients): string {
            const fullDescription = client.description;
            if (this.isExpandedClient(client.id) || fullDescription.length <= 500) {
                return fullDescription;
            }
            return `${fullDescription.slice(0, 200)}...`;
        },

        shouldShowClientReadMore(client: Clients): boolean {
            return client.description.length > 200;
        },

        toggleClientDescription(clientId: number) {
            if (this.expandedClientIds.has(clientId)) {
                this.expandedClientIds.delete(clientId);
            } else {
                this.expandedClientIds.add(clientId);
            }
        },

        isExpandedClient(clientId: number): boolean {
            return this.expandedClientIds.has(clientId);
        },
        getTruncatedText(text: string, limit: number): string {
            if (text.length > limit) {
                return `${text.slice(0, limit)}...`;
            }
            return text;
        },
        getCdnImageAddress(src: string, size: string): string {
            if (!src) return '';
            let cdnUrl: string = environment.imageCdn.getHost;
            cdnUrl = cdnUrl.concat(size);
            return cdnUrl + encodeURIComponent(src);
        },
        useStripHtml(html : string) {
            let regex = /(<([^>]+)>)/ig;
            return html.replace(regex, "");
        },
        closeMenu(){
            (this.$refs.userHeader as any).closeMenu();

        }
    }
});
</script>